import { FetchProps } from '@e3dc-react/shell/Elements/ApiView'
import { InstallationWithoutAccess } from '../models'

/**
 * Fetch installations without access
 * @returns fetch props to fetch installations without access
 */
export const getInstallationsWithoutAccessFetchProps = (companyId: number | undefined, filter: string): FetchProps => {
  if (companyId === undefined) {
    throw new Error('companyId is required')
  }

  return {
    url: `installations/account-links/revoked-access/${companyId}`,
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    filter,
  }
}

export const getInstallationWithoutAccessInstallerName = (installation: InstallationWithoutAccess): string => {
  const { installerFirstName, installerLastName } = installation

  if (installerFirstName || installerLastName) {
    return [installerFirstName, installerLastName].filter(Boolean).join(' ')
  }
  return '---'
}

export const getInstallationWithoutAccessOwnerName = (installation: InstallationWithoutAccess): string => {
  const { ownerFirstName, ownerLastName } = installation
  if (ownerFirstName || ownerLastName) {
    return [ownerFirstName, ownerLastName].filter(Boolean).join(' ')
  }

  return '---'
}

export const checkIsDateLessThanTwoWeeks = (requestedAt: string): boolean => {
  const requestedDate = new Date(requestedAt)
  const currentDate = new Date()

  /* Calculate the difference in time (in milliseconds) */
  const timeDifference = currentDate.getTime() - requestedDate.getTime()

  /* Convert 2 weeks to milliseconds (14 days * 24 hours * 60 minutes * 60 seconds * 1000 ms) */
  const twoWeeksInMilliseconds = 14 * 24 * 60 * 60 * 1000

  // Return true if the difference is less than 2 weeks, otherwise false
  return timeDifference < twoWeeksInMilliseconds
}
